interface ErrorLabelProps {
  error?: string
}

const ErrorLabel = ({ error }: ErrorLabelProps) => (
  <div
    className="error-message-container"
    style={{ color: '#DE5447', padding: '.5em 1em', fontWeight: 300 }}>
    {error}
  </div>
)

export default ErrorLabel
